<template>
  <SidebarPage>

    <template #sidebar>
      <!-- VehicleTypesRegistry сам знает какой элемент выбран и эмитит его наверх,
           Page просто хранит выбранный объект и пробрасывает в VehiclesRegistry -->
      <VehicleTypesRegistry
        v-model="selectedVehicleType"
      />
    </template>

    <template #page>
      <VehiclesRegistry
        :selected-vehicle-type="selectedVehicleType"
      />
    </template>
  </SidebarPage>
</template>


<script lang="ts">

import VehicleType          from '@/domains/VehicleTypes/VehicleType';

import VehicleTypesRegistry from '@/domains/VehicleTypes/components/VehicleTypesRegistry.vue';
import VehiclesRegistry     from '@/domains/Vehicles/components/VehiclesRegistry.vue';

export default defineComponent({
	name: 'VehiclesPage',

	components: {
		VehicleTypesRegistry,
		VehiclesRegistry,
	},

	data() {
		return {
			selectedVehicleType: null as VehicleType | null,
		};
	},
});
</script>
